// Every PULSE client path and API endpoint lives here: nothing else spells them out.

export const PULSE_BASE_PATH = '/pulse';

// Largest id a Postgres INT holds: the backend refuses anything above it.
const PG_INT_MAX = 2_147_483_647;

// Client paths, for links and navigation. `search` is '' or a '?…' query string.
export const pulsePaths = Object.freeze({
  home: (search = '') => `${PULSE_BASE_PATH}${search}`,
  mine: () => `${PULSE_BASE_PATH}/mine`,
  tags: () => `${PULSE_BASE_PATH}/tags`,
  preferences: () => `${PULSE_BASE_PATH}/preferences`,
  stats: () => `${PULSE_BASE_PATH}/stats`,
  privacy: () => `${PULSE_BASE_PATH}/privacy`,
  article: (id) => `${PULSE_BASE_PATH}/articles/${encodeURIComponent(id)}`,
  newArticle: () => `${PULSE_BASE_PATH}/articles/new`,
  editArticle: (id) => `${PULSE_BASE_PATH}/articles/${encodeURIComponent(id)}/edit`,
});

// Route patterns, relative to the `/pulse/*` mount in App.js.
export const PULSE_ROUTE_PATTERNS = Object.freeze({
  mine: 'mine',
  tags: 'tags',
  preferences: 'preferences',
  stats: 'stats',
  privacy: 'privacy',
  article: 'articles/:id',
  newArticle: 'articles/new',
  editArticle: 'articles/:id/edit',
});

// API endpoints, relative to API_BASE_URL (fetchWithAuth prefixes it).
export const pulseEndpoints = Object.freeze({
  articles: () => 'api/pulse/articles',
  article: (id) => `api/pulse/articles/${encodeURIComponent(id)}`,
  publishArticle: (id) => `api/pulse/articles/${encodeURIComponent(id)}/publish`,
  archiveArticle: (id) => `api/pulse/articles/${encodeURIComponent(id)}/archive`,
  articleTranslations: (id) => `api/pulse/articles/${encodeURIComponent(id)}/translations`,
  retryTranslations: (id) => `api/pulse/articles/${encodeURIComponent(id)}/translations/retry`,
  articleLike: (id) => `api/pulse/articles/${encodeURIComponent(id)}/like`,
  articleLikers: (id) => `api/pulse/articles/${encodeURIComponent(id)}/likers`,
  articleReads: (id) => `api/pulse/articles/${encodeURIComponent(id)}/reads`,
  articleReaders: (id) => `api/pulse/articles/${encodeURIComponent(id)}/readers`,
  articleComments: (id) => `api/pulse/articles/${encodeURIComponent(id)}/comments`,
  comment: (id) => `api/pulse/comments/${encodeURIComponent(id)}`,
  adminStats: () => 'api/pulse/admin/stats',
  adminSubscribers: () => 'api/pulse/admin/subscribers',
  myArticles: () => 'api/pulse/me/articles',
  myPrefs: () => 'api/pulse/me/prefs',
  tags: () => 'api/pulse/tags',
  tag: (id) => `api/pulse/tags/${encodeURIComponent(id)}`,
  mergeTag: (id) => `api/pulse/tags/${encodeURIComponent(id)}/merge`,
});

/** A route or payload id as a positive Postgres INT, or null when it cannot be one. */
export const toPulseArticleId = (value) => {
  const text = typeof value === 'number' ? String(value) : value;
  if (typeof text !== 'string' || !/^\d+$/.test(text)) return null;
  const id = Number(text);
  return id > 0 && id <= PG_INT_MAX ? id : null;
};
